






























































































































































































import { Component, Watch, Prop, Vue } from 'vue-property-decorator'
import Local from '@/app/module/local'
/* component */
import PageTitle from '@/app/components/Common/PageTitle.vue'

@Component({
  components: {
    PageTitle
  }
})
export default class MachineSearch extends Vue {
  private search: string = this.$store.state.machineState.searchText
  private constantValue: any
  private status: number = this.$store.state.machineState.isValid
  private machineType: number|null = this.$store.state.machineState.machineType
  private stasusSelected: any = [
    { text: 'すべて', value: null },
    { text: '利用可', value: 0 },
    { text: '利用不可', value: 1 }
  ]

  @Prop() private count!: number

  created () {
    this.constantValue = JSON.parse(Local.getConstantValue()!)
  }

  private doSearch () {
    this.$store.commit('machineState/setSearchText', this.search)
    this.$store.commit('machineState/setIsValid', this.status)
    this.$store.commit('machineState/setMachineType', this.machineType)
    this.$emit('search-list')
  }

  private doClear () {
    this.search = ''
    this.status = 0
    this.machineType = null
    this.$store.commit('machineState/setSearchText', '')
    this.$store.commit('machineState/setIsValid', 0)
    this.$store.commit('machineState/setMachineType', null)
    this.$emit('reset-list')
  }
}
